<template>
  <div>
    <Form ref="searchForm" inline :label-width="80" class="search-form">
      <Form-item label="优惠券状态">
        <Select placeholder="全部状态" v-model="searchCondition.status" style="width:200px" clearable>
          <Option v-for="item in statusList" :value="item.status" :key="item.status">{{ item.name }}</Option>
        </Select>
      </Form-item>
      <Form-item label="优惠券名称">
        <Input
          style="width:200px"
          placeholder="请输入优惠券名称关键字"
          v-model="searchCondition.name"
          clearable
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        :data-url="`/api/coupon/used/log/${this.id}`"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        selectType="none"
        keyField="id"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" @click="open(row.id)">{{action_btn[row.grant]}}-</Button>
          <Button type="text" size="small">{{row.grant==0?"编辑":"领取记录"}}</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "CouponRecord",
  data() {
    return {
      id: this.$route.query.id || "",
      column: [
        {
          title: "优惠券名称",
          key: "coupon",
          align: "center",
          minWidth: 200
        },
        {
          title: "领取人",
          key: "nickname",
          align: "center",
          minWidth: 200
        },
        {
          title: "手机号",
          key: "mobile",
          align: "center",
          minWidth: 180
        },
        {
          title: "领取日期",
          key: "created_at",
          align: "center",
          minWidth: 180
        },
        {
          title: "状态",
          key: "status_name",
          align: "center",
          minWidth: 100
        },
        {
          title: "购买课程",
          key: "course",
          align: "center",
          minWidth: 200
        }
      ],
      selectList: [],
      searchCondition: {
        name: "",
        status: ""
      },
      statusList: [
        { status: 0, name: "未使用" },
        { status: 1, name: "已使用" },
        { status: 2, name: "已过期" }
      ]
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(i => {
        i.created_at = this.$pub.timestampToDay(i.created_at);
        i.course = i.course ? i.course : "--";
        i.status_name =
          i.status == 0 ? "未使用" : i.status == 1 ? "已使用" : "已过期";
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.name = "";
        this.searchCondition.status = "";
      }
      if (typeof this.searchCondition.status == "undefined")
        this.searchCondition.status = "";
      this.$refs.grid.searchRefresh();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
